// extracted by mini-css-extract-plugin
module.exports = {"card":"VideoCardProfileReview_card__MMrac","reviewMeta":"VideoCardProfileReview_reviewMeta__ZpD6g","text":"VideoCardProfileReview_text__2fueF"};